import { useSelector } from "react-redux";
import { getIsUseMediaV2HookEnabled } from "src/state/abTests";
import useMediaV1 from "./useMediaV1";
import useMediaV2 from "./useMediaV2";

const useMedia = <T>(queries: string[], values: T[], defaultValue: T): T => {
  const isUseMediaV2HookEnabled = useSelector(getIsUseMediaV2HookEnabled);

  const dataV1 = useMediaV1(
    isUseMediaV2HookEnabled ? [] : queries,
    isUseMediaV2HookEnabled ? [] : values,
    defaultValue
  );

  const dataV2 = useMediaV2(
    isUseMediaV2HookEnabled ? queries : [],
    isUseMediaV2HookEnabled ? values : [],
    defaultValue
  );

  return isUseMediaV2HookEnabled ? dataV2 : dataV1;
};

export default useMedia;
